import 'bootstrap/dist/css/bootstrap.min.css';
import Rotas from "./routes/Rotas";

function App() {
  return (
    <Rotas />
  );
}

export default App;
